import axios from "axios";
// import api from './api'
import getApiUrl from "./api";
import { watch } from "vue";
import { ElLoading, ElMessage } from "element-plus";
import { getRealJsonData } from "../../hooks/realJson.js";
import { useDemoStore } from "@/pinia/index";
const store = useDemoStore();

const service = axios.create({
  headers: { "Content-Type": "multipart/form-data" },
  baseURL: getApiUrl(),
  timeout: 30000, // 请求超时时间(因为需要调试后台,所以设置得比较大)
  transformResponse: [
    (data) => {
      // 使用JSONbig对返回的数据进行处理
      // console.log(getRealJsonData(data));
      return getRealJsonData(data);
      // return JSONbig.parse(data);
    },
  ],
});

watch(
  () => store.server,
  (newval) => {
    service.defaults.baseURL = getApiUrl();
  }
);

let loadObj;
// request拦截器
service.interceptors.request.use(
  (config) => {
    // if (!loadObj) {
    //   loadObj = ElLoading.service({
    //     lock: true,
    //     text: "Loading",
    //     background: "rgba(0, 0, 0, 0.7)",
    //   });
    // }
    // 请求头添加token
    config.headers["Authorization"] = store.token;
    config.headers["Accept-Language"] = store.lang;
    config.headers["codeKey"] = store.codeKey;
    return config;
  },
  (error) => {
    // setTimeout(() => {
    //   loadObj.close();
    // }, 300);
    return Promise.reject(error);
  }
);

// response 拦截器
service.interceptors.response.use(
  (response) => {
    // setTimeout(() => {
    //   loadObj.close();
    // }, 300);
    const res = response.data;

    if (res.code == 200) {
      return res;
    } else if (res.code == 201) {
      ElMessage(res.msg);
      return res;
    } else {
      return res;
    }
  },
  (error) => {
    // setTimeout(() => {
    //   loadObj.close();
    // }, 300);
    ElMessage(error.message);
    return Promise.reject(error.message);
  }
);
export default service;
